import React from 'react'

/**
 * Separate the page into two components called view and controller.
 * @param view {(model: any) => Element} The graphical part of the component. The parameters will be received by the controller.
 * @param controller {(props: any) => (model: any) => Element} Part with the logic of the component. Should return the parameters
 * requested by the view. Also decides when the component is loading.
 * @param props {any} Other external parameters
 * @returns {Element}
 * @constructor
 */
export default function ModelViewController({ view, controller, ...props }) {
  const Controller = controller
  const View = view

  return (
    <Controller {...props}>
      {({ loading, ...model }) => {
        return loading ? <></> : <View {...props} {...model} />
      }}
    </Controller>
  )
}
